module.exports = __webpack_public_path__ + "media/images/chevron-up-regular-5e663f6c23067fe9ae1315b30b4885ab.svg";